import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
    const examplePrice = 20.50;
    const tuneFee = Math.round(examplePrice * 100 * 0.05) / 100;
    const producerBalance = examplePrice - tuneFee;
    const futureTiers = [
        {
            name: 'Tune Pro Storefront',
            status: 'Coming soon',
            price: 'TBD',
            description: 'Optional growth tools for producers who want a stronger storefront without changing the buyer fee promise.',
            features: ['Advanced profile analytics', 'Featured storefront tools', 'Custom promo links', 'Catalog promotion controls'],
        },
        {
            name: 'Tune Studio',
            status: 'Coming soon',
            price: 'TBD',
            description: 'A team tier for producers, engineers, and labels managing bigger catalogs and payout operations.',
            features: ['Team catalog access', 'Split and collaborator tools', 'Bulk upload support', 'Priority payout review'],
        },
    ];

    return (
        <main className="pricing-page">
            <section className="pricing-hero">
                <div className="pricing-hero-copy">
                    <p className="pricing-eyebrow">Pricing</p>
                    <h1>Clear fees for artists. Fair earnings for producers.</h1>
                    <p>
                        Tune keeps checkout simple: buyers pay the listed beat price, producers keep 95%,
                        and Tune takes 5% from each completed marketplace sale.
                    </p>
                    <div className="pricing-actions">
                        <Link to="/marketplace" className="pricing-button pricing-button-primary">Browse Beats</Link>
                        <Link to="/upload" className="pricing-button pricing-button-secondary">Start Selling</Link>
                    </div>
                </div>
                <div className="pricing-hero-panel" aria-label="Launch fee summary">
                    <span>Launch marketplace</span>
                    <strong>5%</strong>
                    <p>Tune fee from completed sales. No added buyer platform fee.</p>
                    <div>
                        <small>Producer keeps</small>
                        <b>95%</b>
                    </div>
                </div>
            </section>

            <section className="pricing-proof-strip" aria-label="Pricing promises">
                <div>
                    <strong>No buyer platform fee</strong>
                    <span>The checkout total matches the listed beat price.</span>
                </div>
                <div>
                    <strong>Simple seller split</strong>
                    <span>Tune takes 5%, producer balance receives 95%.</span>
                </div>
                <div>
                    <strong>Paid license records</strong>
                    <span>Completed purchases are saved to the buyer Library.</span>
                </div>
            </section>

            <section className="pricing-grid" aria-label="Tune pricing policy">
                <article className="pricing-card pricing-card-featured">
                    <span className="pricing-badge">Launch policy</span>
                    <h2>Marketplace sales</h2>
                    <div className="pricing-rate">
                        <strong>5%</strong>
                        <span>Tune fee</span>
                    </div>
                    <ul>
                        <li>Buyer platform fee: $0</li>
                        <li>Producer balance: 95%</li>
                        <li>Fee is taken from the listed beat price</li>
                        <li>Licenses are delivered to the buyer Library</li>
                    </ul>
                </article>

                <article className="pricing-card">
                    <h2>For buyers</h2>
                    <div className="pricing-rate">
                        <strong>$0</strong>
                        <span>added buyer fee</span>
                    </div>
                    <p>
                        The price on the beat is the price at checkout. Card details are handled by Stripe,
                        and Tune keeps purchase records in your Library.
                    </p>
                </article>

                <article className="pricing-card">
                    <h2>For producers</h2>
                    <div className="pricing-rate">
                        <strong>95%</strong>
                        <span>producer balance</span>
                    </div>
                    <p>
                        Producers earn 95% of each completed sale. Tune tracks earnings in the producer
                        profile and withdrawal workflow.
                    </p>
                </article>
            </section>

            <section className="pricing-tiers" aria-label="Future Tune pricing tiers">
                <div className="pricing-section-heading">
                    <p className="pricing-eyebrow">Future tiers</p>
                    <h2>Optional upgrades, not a launch requirement.</h2>
                    <p>
                        The marketplace stays simple at launch. These tiers are the roadmap for producers who later want
                        more tools, while buyers still avoid added platform fees.
                    </p>
                </div>
                <div className="pricing-tier-grid">
                    <article className="pricing-tier-card pricing-tier-card-live">
                        <div className="pricing-tier-topline">
                            <span className="pricing-tier-status">Live now</span>
                            <strong>$0/mo</strong>
                        </div>
                        <h3>Launch Marketplace</h3>
                        <p>
                            List beats, sell licenses, and keep 95% of each sale with no monthly plan required.
                        </p>
                        <ul>
                            <li>5% Tune fee on completed sales</li>
                            <li>$0 buyer platform fee</li>
                            <li>Producer profile and Library delivery</li>
                        </ul>
                    </article>
                    {futureTiers.map((tier) => (
                        <article className="pricing-tier-card" key={tier.name}>
                            <div className="pricing-tier-topline">
                                <span className="pricing-tier-status">{tier.status}</span>
                                <strong>{tier.price}</strong>
                            </div>
                            <h3>{tier.name}</h3>
                            <p>{tier.description}</p>
                            <ul>
                                {tier.features.map((feature) => (
                                    <li key={feature}>{feature}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>

            <section className="pricing-example" aria-label="Example sale breakdown">
                <div>
                    <p className="pricing-eyebrow">Example</p>
                    <h2>If a beat is listed at ${examplePrice.toFixed(2)}</h2>
                </div>
                <div className="pricing-breakdown">
                    <div>
                        <span>Buyer pays</span>
                        <strong>${examplePrice.toFixed(2)}</strong>
                    </div>
                    <div>
                        <span>Tune fee (5%)</span>
                        <strong>${tuneFee.toFixed(2)}</strong>
                    </div>
                    <div>
                        <span>Producer balance</span>
                        <strong>${producerBalance.toFixed(2)}</strong>
                    </div>
                </div>
            </section>

            <section className="pricing-note">
                <h2>Why keep it this simple?</h2>
                <p>
                    We are building Tune around trust. No surprise buyer fees, no confusing monthly plans
                    required to sell, and a clear marketplace cut that is easy to explain before money moves.
                </p>
            </section>
        </main>
    );
};

export default Pricing;
